// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarShopTeaser__container","title":"SidebarShopTeaser__title","priceTag":"SidebarShopTeaser__priceTag","fadeIn":"SidebarShopTeaser__fadeIn"};